import { makeAutoObservable } from 'mobx'
import { type ReactNode } from 'react'
import type { IGlobalAlert } from 'shared/ui'

export class Banner {
  readonly id: string
  readonly alert: IGlobalAlert['alert']
  readonly action: IGlobalAlert['action']
  readonly secondAction: IGlobalAlert['secondAction']
  readonly actionClose: IGlobalAlert['actionClose']

  constructor(item: IGlobalAlert) {
    this.id = item.id
    this.alert = item.alert
    this.action = item.action
    this.secondAction = item.secondAction
    this.actionClose = item.actionClose

    makeAutoObservable(this)
  }

  setAlertTitle = (value: ReactNode) => {
    this.alert.title = value
  }
}
